import { render, staticRenderFns } from "./DataSetHeader.vue?vue&type=template&id=3afb5a94&scoped=true"
import script from "./DataSetHeader.vue?vue&type=script&lang=js"
export * from "./DataSetHeader.vue?vue&type=script&lang=js"
import style0 from "./DataSetHeader.vue?vue&type=style&index=0&id=3afb5a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb5a94",
  null
  
)

export default component.exports